import { useAuthStore } from '../store/auth';

/**
 * Renders children only when the current admin can mutate data.
 * Use to wrap "Create / New" buttons, row action menus, and similar
 * write-only UI so read-only users don't see disabled controls.
 */
export function EditOnly({ children }: { children: React.ReactNode }) {
  const canEdit = useAuthStore((s) => s.canEdit());
  if (!canEdit) return null;
  return <>{children}</>;
}

export function useCanEdit() {
  return useAuthStore((s) => s.canEdit());
}
